export const getArea = (item: any) =>
  item["DBO.Plots_39.Area"] ?? item["DBO.Plots_40.Area"];

export const getFid = (item: any) =>
  (item["DBO.Plots_39.fid"] ?? item["DBO.Plots_40.fid"] ?? "").toString();
